import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { ListDTO, ListResponseAPI } from 'src/lib/queries';
import { Voucher } from 'src/features/vouchers/utils/types';

const RESOURCE = '/discounts/voucher/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    customer?: string;
    voucher_type?: string;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<Voucher>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_VOUCHERS_RESOURCE, useQueryHook as useListVouchers };
